module.exports = __webpack_public_path__ + "static/img/zhutu消防车.5228988.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhutu消防车.png
// module id = xSTk
// module chunks = 0